'use client';

import dynamic from 'next/dynamic';

export const HelpCenterCoreWrapper = dynamic(
  () => import('@portals/help-center-core').then((mod) => mod.HelpCenterLib),
  {
    ssr: false,
  },
);
